// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__b2W1m","name":"styles_name__2BUG7","phone":"styles_phone__1Zdc_"};